import { useEffect, useState } from 'react';
import { FiClipboard } from 'react-icons/fi';
import { AppLayout } from '../../components/AppLayout';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { atualizarStatusPedido, listarPedidos } from '../../api/pedidos';
import { Pedido } from '../../types';

const COLUNAS: Array<{ status: Pedido['status']; titulo: string; proximo: Pedido['status']; acaoLabel: string }> = [
  { status: 'recebido', titulo: 'Recebido', proximo: 'preparo', acaoLabel: 'Iniciar preparo' },
  { status: 'preparo', titulo: 'Em preparo', proximo: 'pronto', acaoLabel: 'Marcar como pronto' },
  { status: 'pronto', titulo: 'Pronto', proximo: 'entregue', acaoLabel: 'Finalizar' },
  { status: 'em_entrega', titulo: 'Em entrega', proximo: 'entregue', acaoLabel: 'Marcar entregue' },
];

const POLLING_MS = 5000;

export function Kds() {
  const [pedidos, setPedidos] = useState<Pedido[]>([]);
  const [carregando, setCarregando] = useState(true);

  function carregar() {
    listarPedidos()
      .then(setPedidos)
      .finally(() => setCarregando(false));
  }

  useEffect(() => {
    carregar();
    const intervalo = setInterval(carregar, POLLING_MS);
    return () => clearInterval(intervalo);
  }, []);

  async function avancarStatus(pedido: Pedido, proximoStatus: Pedido['status']) {
    await atualizarStatusPedido(pedido.id, proximoStatus);
    carregar();
  }

  return (
    <AppLayout>
      <div className="lizzi-cabecalho-pagina">
        <h1>
          <span className="lizzi-icone-titulo">
            <FiClipboard size={18} />
          </span>
          Cozinha (KDS)
        </h1>
      </div>

      {carregando ? (
        <p>Carregando...</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
          {COLUNAS.map((coluna) => {
            const pedidosDaColuna = pedidos.filter((pedido) => pedido.status === coluna.status);

            return (
              <div key={coluna.status}>
                <h2 style={{ fontSize: '14px', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.03em', color: 'var(--cor-primaria)' }}>
                  {coluna.titulo} ({pedidosDaColuna.length})
                </h2>

                {pedidosDaColuna.map((pedido) => (
                  <Card key={pedido.id} hover style={{ padding: '14px', marginBottom: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, gap: '12px' }}>
                      <span>{pedido.numero_pedido ? `#${pedido.numero_pedido}` : `#${pedido.id}`}</span>
                      <span>{pedido.identificacao_cliente || 'Balcao'}</span>
                    </div>

                    {pedido.itens.length > 0 ? (
                      <ul style={{ margin: '8px 0', paddingLeft: '18px', fontSize: '13px' }}>
                        {pedido.itens.map((item, index) => (
                          <li key={index}>
                            {Number(item.quantidade)}x {item.nome}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p style={{ margin: '10px 0', color: '#5c6b84', fontSize: '13px' }}>
                        Pedido de entrega cadastrado sem itens detalhados.
                      </p>
                    )}

                    {pedido.motoboy_nome ? (
                      <p style={{ margin: '0 0 10px', color: '#5c6b84', fontSize: '12px' }}>Motoboy: {pedido.motoboy_nome}</p>
                    ) : null}

                    <Button onClick={() => avancarStatus(pedido, coluna.proximo)}>{coluna.acaoLabel}</Button>
                  </Card>
                ))}

                {pedidosDaColuna.length === 0 && (
                  <p style={{ fontSize: '13px', color: 'var(--cor-texto)', opacity: 0.6 }}>Nenhum pedido aqui.</p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </AppLayout>
  );
}
